const OBSERVE_TARGET_CLASSNAME = 'main-product-buy-button'
const SCROLL_ANIMATION_CLASSNAME = 'slide-in'

if (!customElements.get('product-floating-banner')) {
  customElements.define(
    'product-floating-banner',
    class ProductFloatingBanner extends HTMLElement {
      constructor() {
        super();

        this.input = this.querySelector('.quantity__input');
        this.currentVariant = this.querySelector('.product-variant-id');
        this.currentPrice = this.querySelector(`.price`)
        this.submitButton = this.querySelector('[type="submit"]');
      }

      cartUpdateUnsubscriber = undefined;
      variantChangeUnsubscriber = undefined;
      quantityUpdateUnsubscriber = undefined;

      connectedCallback() {
        this.slideInAnimationDependScroll()
        window.addEventListener('scroll', () => this.slideInAnimationDependScroll())

        if (!this.input) return;
        this.quantityForm = this.querySelector('.product-form__quantity');
        if (!this.quantityForm) return;
        this.setQuantityBoundries();
        if (!this.dataset.originalSection) {
          this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.fetchQuantityRules.bind(this));
        }

        this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.updateQuantity.bind(this));

        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, this.fetchVariantPrice.bind(this));
      }

      disconnectedCallback() {
        if (this.cartUpdateUnsubscriber) {
          this.cartUpdateUnsubscriber();
        }
        if (this.variantChangeUnsubscriber) {
          this.variantChangeUnsubscriber();
        }
      }
      setQuantityBoundries() {
        const data = {
          cartQuantity: this.input.dataset.cartQuantity ? parseInt(this.input.dataset.cartQuantity) : 0,
          min: this.input.dataset.min ? parseInt(this.input.dataset.min) : 1,
          max: this.input.dataset.max ? parseInt(this.input.dataset.max) : null,
          step: this.input.step ? parseInt(this.input.step) : 1,
        };

        let min = data.min;
        const max = data.max === null ? data.max : data.max - data.cartQuantity;
        if (max !== null) min = Math.min(min, max);
        if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

        this.input.min = min;
        this.input.max = max;
        this.input.value = min;
        publish(PUB_SUB_EVENTS.quantityUpdate, this.input.value);
      }

      fetchQuantityRules() {
        if (!this.currentVariant || !this.currentVariant.value) return;

        const loadingSpinner = this.querySelector('.quantity__rules-cart .loading__spinner');
        if (loadingSpinner) {
          loadingSpinner.classList.remove('hidden');
        }

        fetch(`${this.dataset.url}?variant=${this.currentVariant.value}&section_id=${this.dataset.section}`)
          .then((response) => {
            return response.text();
          })
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            this.updateQuantityRules(this.dataset.section, html);

            this.setQuantityBoundries();
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            if (loadingSpinner) {
                loadingSpinner.classList.add('hidden');
              }
          });
      }

      updateQuantityRules(sectionId, html) {
        const quantityFormUpdated = html.getElementById(`Quantity-Form-${sectionId}`);
        const selectors = ['.quantity__input', '.quantity__rules', '.quantity__label'];
        for (let selector of selectors) {
          const current = this.quantityForm.querySelector(selector);
          const updated = quantityFormUpdated.querySelector(selector);
          if (!current || !updated) continue;
          if (selector === '.quantity__input') {
            const attributes = ['data-cart-quantity', 'data-min', 'data-max', 'step'];
            for (let attribute of attributes) {
              const valueUpdated = updated.getAttribute(attribute);
              if (valueUpdated !== null) current.setAttribute(attribute, valueUpdated);
            }
          } else {
            current.innerHTML = updated.innerHTML;
          }
        }
      }

      slideInAnimationDependScroll() {
        const [productFormElm] = document.getElementsByClassName(OBSERVE_TARGET_CLASSNAME)
        const [footerElm] = document.getElementsByTagName('footer')

        const viewportHeight = window.innerHeight;
        const scrollY = window.scrollY;

        const elementPositionY = productFormElm.getBoundingClientRect().top + scrollY;
        const elementHeight = productFormElm.offsetHeight;
        const targetPosition = elementPositionY + elementHeight

        const footerPositionY = footerElm.getBoundingClientRect().top + scrollY;
        const footerPosition = footerPositionY - viewportHeight

        if (scrollY > (targetPosition - viewportHeight) && scrollY < targetPosition) {
          this.classList.remove('slideIn')
        } else if (scrollY > footerPosition) {
          this.classList.remove('slideIn')
        } else {
          this.classList.add('slideIn')
        }

      }

      updateQuantity(value) {
        this.input.value = value;
      }

      fetchVariantPrice(event) {
        const sectionId = this.dataset.section
        if (!sectionId) return;

        fetch(`${this.dataset.url}?variant=${event.data.variant.id}&section_id=${this.dataset.section}`)
          .then((response) => {
            return response.text();
          })
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            this.updateQuantityRules(sectionId, html);
            this.updatePrice(sectionId, html)
          })

        this.setQuantityBoundries();
      }

      updatePrice(sectionId, html) {
        const priceUpdated = html.getElementById(`price-${sectionId}`);
        const current = this.currentPrice
        const updated = priceUpdated.querySelector('.price')

        if (!current || !updated) return;
        current.innerHTML = updated.innerHTML

      }
    }

  );
}